export default class CategoryAccordion {
    constructor() {
        const panels = document.querySelectorAll(".category-accordion");

        panels.forEach((panel) => {
            panel.addEventListener("click", () => {
                removeActiveClasses();
                panel.classList.add("active");
            });
        });

        function removeActiveClasses() {
            panels.forEach((panel) => {
                panel.classList.remove("active");
            });
        }

        this.openOutdoor();
    }

    openOutdoor() {
        const outdoorAccordion = document.getElementById('single-accordion__Outdoor');

        outdoorAccordion?.classList.add('active');
    }
}